<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chaptertitle3">Contents</h2>
<p class="toc"><a href="#/series">Series Foreword</a></p>
<p class="toc"><a href="#/ack">Acknowledgments</a></p>
<p class="toc"><a href="#/itr">Introduction: Democratic Vistas Today</a></p>
<p class="toca"><a href="#/itr"><i>John E. Seery</i></a></p>
<p class="tocp"><a href="#/part1"><b>PART I. INDIVIDUALITY AND CONNECTEDNESS</b></a></p>
<p class="toc"><a href="#/chap1">1. Walt Whitman and the Culture of Democracy</a></p>
<p class="toca"><a href="#/chap1"><i>George Kateb</i></a></p>
<p class="toc"><span href="#/chap2" title="Link target outside of Sample">2. Strange Attractors: How Individualists Connect to Form Democratic Unity</span></p>
<p class="toca"><span href="#/chap2" title="Link target outside of Sample"><i>Nancy L. Rosenblum</i></span></p>
<p class="toc"><span href="#/chap3" title="Link target outside of Sample">3. Mestiza Poetics: Walt Whitman, Barack Obama, and the Question of Union</span></p>
<p class="toca"><span href="#/chap3" title="Link target outside of Sample"><i>Cristina Beltran</i></span></p>
<p class="toc"><span href="#/chap4" title="Link target outside of Sample">4. Democratic Desire: Walt Whitman</span></p>
<p class="toca"><span href="#/chap4" title="Link target outside of Sample"><i>Martha C. Nussbaum</i></span></p>
<p class="toc"><span href="#/chap5" title="Link target outside of Sample">5. The Solar Judgment of Walt Whitman</span></p>
<p class="toca"><span href="#/chap5" title="Link target outside of Sample"><i>Jane Bennett</i></span></p>
<p class="tocp"><span href="#/part2" title="Link target outside of Sample"><b>PART II. CITY LIFE AND BODILY PLACE</b></span></p>
<p class="toc"><span href="#/chap6" title="Link target outside of Sample">6.“Mass Merger”: Whitman and Baudelaire, the Modern Street, and Democratic Culture</span></p>
<p class="toca"><span href="#/chap6" title="Link target outside of Sample"><i>Marshall Berman</i></span></p>
<p class="toc"><span href="#/chap7" title="Link target outside of Sample">7. Promiscuous Citizenship</span></p>
<p class="toca"><span href="#/chap7" title="Link target outside of Sample"><i>Jason Frank</i></span></p>
<p class="toc"><span href="#/chap8" title="Link target outside of Sample">8. Walt Whitman and the Ethnopoetics of New York</span></p>
<p class="toca"><span href="#/chap8" title="Link target outside of Sample"><i>Michael J. Shapiro</i></span></p>
<p class="toc"><span href="#/chap9" title="Link target outside of Sample">9. Democratic Manliness</span></p>
<p class="toca"><span href="#/chap9" title="Link target outside of Sample"><i>Terrell Carver</i></span></p>
<p class="tocp"><span href="#/part3" title="Link target outside of Sample">PART III. DEATH AND CITIZENSHIP</span></p>
<p class="toc"><span href="#/chap10" title="Link target outside of Sample">10. Whitman as a Political Thinker</span></p>
<p class="tocb"><span href="#/chap10" title="Link target outside of Sample"><i>Peter Augustine Lawler</i></span></p>
<p class="toc"><span href="#/chap11" title="Link target outside of Sample">11. Whitman, Death, and Democracy</span></p>
<p class="tocb"><span href="#/chap11" title="Link target outside of Sample"><i>Jack Turner</i></span></p>
<p class="toc"><span href="#/chap12" title="Link target outside of Sample">12. Morbid Democracies: The Bodies Politic of Walt Whitman and Richard Rorty</span></p>
<p class="tocb"><span href="#/chap12" title="Link target outside of Sample"><i>Kennan Ferguson</i></span></p>
<p class="toc"><span href="#/chap13" title="Link target outside of Sample">13. Democratic Enlightenment: Whitman and Aesthetic Education</span></p>
<p class="tocb"><span href="#/chap13" title="Link target outside of Sample"><i>Morton Schoolman</i></span></p>
<p class="toc"><span href="#/frontispieces" title="Link target outside of Sample"><b>Frontispieces from <i>Leaves of Grass</i></b></span></p>
<p class="toc"><span href="#/frontispieces" title="Link target outside of Sample">1855 edition</span></p>
<p class="toc"><span href="#/frontispieces1" title="Link target outside of Sample">1860 edition</span></p>
<p class="toch"><span href="#/bib" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/contri" title="Link target outside of Sample">List of Contributors</span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2717c20a